$(function() {
  var $date = $("#date");
  if (!$date.length) return;

  var blockWeekends = $date.data("block-weekends") === true;

  // Metaobject blocked dates — Liquid se aati hain, format: "2026-12-25,2026-12-26,"
  var blockedDates = ($date.attr("data-blocked-dates") || "")
    .split(",")
    .map(function(d) { return d.trim(); })
    .filter(function(d) { return d !== ""; });

  function toISO(date) {
    var y = date.getFullYear();
    var m = ("0" + (date.getMonth() + 1)).slice(-2);
    var d = ("0" + date.getDate()).slice(-2);
    return y + "-" + m + "-" + d;
  }

  $date.datepicker( {
    minDate: +1,
    //maxDate: '+4M',
    dateFormat: 'dd/mm/yy',
    beforeShowDay: function(date) {
      if (blockWeekends) {
        var day = date.getDay();
        if (day === 0 || day === 6) {
          return [false, '', 'No weekend deliveries'];
        }
      }
      if (blockedDates.indexOf(toISO(date)) !== -1) {
        return [false, '', 'Not available on this date'];
      }
      return [true, ''];
    }
  } );
});
